<template>
<div class="background-layer">
  <div class="page container mx-auto relative">
    <div class="heading h-screen">
      <div class="logo lg:w-1/3 xl:w-1/3 md:w-1/2 mx-auto pt-12">

        <a href="https://portal.mozgo.com/" target="_blank"><img src="../assets/logo.png" alt="MOZGO_BIG"></a>
        <img src="../assets/stub.png" alt="MOZGO_BIG">
      </div>
      <div class="stats pt-10 flex flex-row flex-wrap justify-center -m-3 relative">
               <StatItem  v-for="(stat, key) in stats" :key="key" :stat="stat" />
        
      </div>
      <MouseDown />
    </div>
    <div class=" h-screen pt-24" id="list">
        <h1 class="mx-auto text-center text-3xl font-extrabold text-white">Общий рейтинг команд&nbsp;серии&nbsp;игр «Большая&nbsp;игра»</h1>
        <MozgoTable class="mt-12 mb-4" />
    </div>
  </div>
</div>
</template>

<script>
import StatItem from './Helpers/StatItem';
import MouseDown from './Helpers/MouseDown';
import MozgoTable from './Table/MozgoTable';

export default {
  name: 'MainPage',
  components: {
    StatItem,
    MouseDown,
    MozgoTable
  },
  data() {
    return {
      stats: [
        {count: '118 ' ,type:'городов', description: 'Общее количество городов'},
        {count: '148 ' ,type:'игр', description: 'Общее количество игр'},
        {count: '17 810 ' ,type:'игроков', description: 'Общее количество игроков'},
        {count: '44,5 ' ,type:'баллов', description: 'Средний балл победителя'},
        {count: '4 ' ,type:'балла', description: 'Минимальный балл по играм'},
        {count: '71 ' ,type:'балл', description: 'Максимальный балл по играм'},
      ]         
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background-layer {
  position: fixed;
  background-image: url('../assets/background.png');
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-size: cover;
  overflow-y: scroll;
  scroll-behavior: smooth;
}
@media screen and (min-width: 800px) and (max-width: 1280px)  {
  .heading{
    height: auto !important;
  }

}
@media screen and (min-width: 300px) and (max-width: 800px)  {
  .heading{
    height: auto !important;
  }

}
</style>
